import { Base } from ".";
import { bestFitForSolar } from "../sample";

export const BestFitForEV = ({ building, onClose }) => {
  return (
    <Base
      headerTitle="Best Fit For EV"
      building={building}
      secondButton="APPROVE NEW EV ASSET"
      data={bestFitForSolar}
      onClose={onClose}
    />
  );
};
